import { type DocNode } from '@atlaskit/adf-schema';
import { reduce } from '@atlaskit/adf-utils/traverse';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

export type ContentFeatures = {
	adfLength: number;
	textLength: number;
	wordCount: number;
	linkCount: number;
	mentionCount: number;
};

const wordCount = (text?: string) => {
	if (text) {
		const matches = text.match(/\S+/g);
		if (matches) {
			return matches.length;
		}
	}
	return 0;
};
const processADFNode = (currentValue: ContentFeatures, node: ADFEntity): ContentFeatures => {
	switch (node.type) {
		case 'text':
			const linkCount = node.marks?.some((mark) => mark.type === 'link')
				? currentValue.linkCount + 1
				: currentValue.linkCount;
			return {
				...currentValue,
				textLength: currentValue.textLength + (node.text ? node.text.length : 0),
				wordCount: currentValue.wordCount + wordCount(node.text),
				linkCount,
			};
		case 'mention':
			return {
				...currentValue,
				mentionCount: currentValue.mentionCount + 1,
			};
		case 'inlineCard':
		case 'embedCard':
			return {
				...currentValue,
				linkCount: currentValue.linkCount + 1,
			};
	}
	return currentValue;
};

export const extractContentFeatures = (adf: DocNode): ContentFeatures => {
	const initialFeatures: ContentFeatures = {
		adfLength: JSON.stringify(adf).length,
		textLength: 0,
		wordCount: 0,
		linkCount: 0,
		mentionCount: 0,
	};

	return reduce<ContentFeatures>(
		adf,
		(currentValue, node: ADFEntity) => processADFNode(currentValue, node),
		initialFeatures,
	);
};
